import styled from 'styled-components';
import { colorPallet } from '../../../styles/global';

export const Container = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: none;
  background: white;

  span + span {
    margin-top: 5px;
  }
  span{
    width: 25px;
    height: 2px;
    background: ${colorPallet.darkBlue};
  }
`;
